module.exports = __webpack_public_path__ + "img/vote-btn_txt_end.95596f2a.png";